module.exports = __webpack_public_path__ + "fonts/dljk.d0435e39.woff2";